import {
  Box,
  Button,
  ControllerModal,
  DialogContent,
  Typography,
} from '@bymason-private/legacy-pattern-components';
import { XrayRtcFeature } from '@bymason/controller-api-hooks';

interface SessionEndWarningModalProps {
  feature: XrayRtcFeature;
  open: boolean;
  onClose: (proceed?: boolean) => void;
}

const featureMap: Record<string, string> = {
  ['remote-control']: 'remote control',
  ['log-stream']: 'streaming logs',
};

export function SessionEndWarningModal({ onClose, open, feature }: SessionEndWarningModalProps) {
  const handleProceed = () => {
    onClose(true);
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <ControllerModal
      onClose={handleCancel}
      open={open}
      subTitle={`Changing tabs will end your ${featureMap[feature] || 'X-Ray'} session.`}
      title={`${featureMap[feature] ? `X-Ray ${featureMap[feature]}` : 'X-Ray'} session is active`}
    >
      <DialogContent sx={{ maxWidth: '30vw', minWidth: 480 }}>
        <Typography pb={2}>Do you want to proceed with tab change?</Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            gap: 2,
            marginTop: 7,
          }}
        >
          <Button color='secondary' onClick={handleCancel} size='medium' variant='text'>
            Cancel
          </Button>
          <Button color='primary' onClick={handleProceed} size='medium' variant='contained'>
            Yes, proceed
          </Button>
        </Box>
      </DialogContent>
    </ControllerModal>
  );
}
